import { getPlatforms, getRechargeTemplates, getVideos, addVideo, adCallbackConfigs,getKvData } from '@/api/open'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import { createPt} from '@/api/advertiser'
import { syncAdCallbackConfig } from '@/api/advertiser'

export default {
    components: {
        MaterialSelect,
    },
    props: {
        showCreatePtZyForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created() {
        if (this.model.id) {
            this.actionName = '修改'
        } else {
            this.actionName = '新建'
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                name: [
                    { required: true, message: '请输入推广链接名称', trigger: 'blur' },
                    {
                        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9-]+$/,
                        message: '推广链接名称只能输入汉字、字母、数字和中划线',
                        trigger: 'blur'
                    }
                ]
            },
            baseRules: {
                platform_id: [{ required: true, message: '请选择平台', trigger: 'change' }],
                name: [{ required: true, message: '请填写推广链接名称', trigger: 'change' }],
            },
            netServiceTypes: [{ type: 'MICRO_APP', name: '跳转微信' }],
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showResultAndCreate: false,
            showSubmit: true,
            platforms: [],
            rechargeTemplates: [],
            videos: [],
            addvideoModel: {
                video_id: null,
                video_name: null,
            },
            showCreateAddForm: false,
            mediaSources: [
                {id:1, name:'巨量'},
            ],
            adCallbackConfigs: [],
            showConfigs: [],
            channels: [],
            channel_id: null,
            // rows: [],  // 初始化 rows 数组为空
            autoSelect: false,
            fixedPanel: false,
            pt_rules: [], //固定面板规则
            platformTypes : [
                {type:15, name:'掌阅'},
            ],
            default_video_id: "",
            default_start_chapter: null,
            chapterNums:[]
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        this.getChapterNums()
        // console.log('进入', this.model)
        this.initData()
    },
    watch: {},
    methods: {
        initData(isChange = false) {
            this.model.platform_id = null
            this.addRow()

            getPlatforms({ type: this.model.platform_type, enabled:1 }).then(res => {
                this.platforms = res.data.list || []
            })

            // TODO----这里新增测试数据
            // this.model.selectAdvertisers.forEach((advertiser, index) => {
            //     if (index === 0) {
            //         advertiser.remark = "测6.21wp-[幸孕双宝：爹地每天都在装穷][27]"
            //     } else if (index === 1) {
            //         advertiser.remark = "测6.21wp-公主小妹之千金归来-12"
            //     } else if (index === 2) {
            //         advertiser.remark = "测6.21wp-归来的千金清风拂面-9"
            //     } else if (index === 3) {
            //         advertiser.remark = "最美年华邂逅你-8"
            //     }
            // });
    
            this.changePlatform(isChange)
        },
        createRow(adv_ids = null, rules = null) {

            if (adv_ids == null) {
                adv_ids = this.model.ids
            }

            let video_id = this.default_video_id || ''
            // 未匹配到短剧信息，收费章节默认为空
            let start_chapter = this.default_start_chapter || null
            if (!video_id) {
                start_chapter = null
            }
            let recharge_template_id = ''
            let follow_recharge_template_id = ''
            let ad_callback_config_id = null

            if (this.autoSelect) {
                //自动填充开，自动填充第一组【短剧】和【起始付费集】
                video_id = this.model.rows[0].video_id
                start_chapter = this.model.rows[0].start_chapter
            }
            // if (this.model.platform_id && this.model.platform_id == 25) {
            //     ad_callback_config_id = 1791590421346313
            // }
            
            let media_source = 1
            let price = null
            // console.log('bb', this.model.platform_id)
            if (this.model.platform_id && this.model.platform_id == 36) {
                price = 0.66
            }

            if (rules && rules.ad_callback_name) {
                // console.log('aaa', rules)
                // console.log('rechargeTemplates', this.rechargeTemplates)
                price = rules.price

                let adCallbacks = this.showConfigs[media_source]
                 
                //寻找名称为rules.ad_callback_name
                adCallbacks.forEach(element => {
                    if (element.name === rules.ad_callback_name) {
                        ad_callback_config_id = element.out_id
                    }
                });

                //寻找名称为rules.recharge_template_name
                this.rechargeTemplates.forEach(element => {
                    if (element.name === rules.recharge_template_name) {
                        recharge_template_id = element.id
                    }
                    if (element.name === rules.follow_recharge_template_name) {
                        follow_recharge_template_id = element.id
                    }
                });
            }

            this.getChapterNums(video_id)

            return {
                adv_ids: adv_ids,
                video_id: video_id,
                chapter_num: 1,
                start_chapter: start_chapter,
                price: price,
                recharge_template_id: recharge_template_id,
                follow_recharge_template_id: follow_recharge_template_id,
                media_source: media_source,
                ad_callback_config_id: ad_callback_config_id,
                // pack_strategy_status:1,
                guide_chapter: 0,
            };
          },
        submit() {
            // console.log('验证前',this.rules)
            this.$refs.form.validate(valid => {
                if (!valid) {
                    this.showResultAndCreate = false

                    // 定义每个字段对应的提示文案
                    const requiredFields = [
                        { key: 'recharge_template_id', label: '【首充模版】' },
                        { key: 'follow_recharge_template_id', label: '【复充模版】' },
                        { key: 'video_id', label: '【短剧ID】' },
                        { key: 'start_chapter', label: '【起始付费集数】' },
                        { key: 'price', label: '【单集价格】' },
                        { key: 'ad_callback_config_id', label: '【回传规则】' }
                    ]
                    for (const field of requiredFields) {
                        const missingIndex = this.model.rows.findIndex(item => !item[field.key])
                        if (missingIndex !== -1) {
                            this.$message.error(`第 ${missingIndex + 1} 组的${field.label}未填写`)
                            this.showResultAndCreate = false
                            return
                        }
                    }

                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            if (!this.model.platform_id) {
                this.showResultAndCreate = false
                this.$message.error('请先选择平台')
                return
            }
            const data = Object.assign({}, this.model)
            // console.log('提交的数据', data)

            this.result.success = []
            this.result.errors = []

            this.loading = true

            // console.log('提交后：',this.rules)
            createPt(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    //出现弹窗，提示结果不关闭，关闭弹窗，才刷新
                    if (!this.showResultAndCreate ) {
                        this.showResult = true
                    }
                    // this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
                this.showSubmit = false
            }).catch(() => {
                this.loading = false
                this.showSubmit = true
            })
           
        },
        test(){
            createPt()
        },
        closerResult() {
            this.showResult = false
            if (this.result && this.result.success.length>0 && this.result.errors.length == 0) {
                this.$emit('success')
                this.close()
            }
        },
        next (version_type = 1) {
            this.showResultAndCreate = true
            this.submit()
         
            if (!this.showResultAndCreate) {
                return
            }

            this.loading = true
           //如果有失败，则提示
            if (!this.showResultAndCreate || this.result.errors.length > 0) {
                this.$message.error('批量创建推广链接失败，创建小程序终止！')
                this.showResult = true
                return
            }

            //需要sleep 5秒
            setTimeout(() => {
                this.loading = false
                //开始弹窗批量创建小程序
                this.showResult = false
                this.$emit('next')
                this.$emit('next2', version_type)
                this.close()
            }, 3000)
          
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showCreatePtZyForm', false)
        },
        changePlatformType () {
            this.rechargeTemplates = []
            this.adCallbackConfigs = []
            this.showConfigs = []
            this.initData(true)
        },
        changePlatform(isChange = false) {
            if (this.model.platform_id || isChange) {

               this.model.distributor_id = ''
               this.model.pay_type = null

               this.model.rows = [this.createRow()]


               this.generateRules()
               //需要从this.platforms中获取对应的pay_type,条件是this.platforms的id=this.model.platform_id
               this.platforms.forEach(element => {
                    if (this.model.platform_id === element.id) {
                        this.model.pay_type = element.pay_type
                    }
                });

                if (this.model.platform_id) {
                    getVideos({ platform_id: this.model.platform_id }).then(res => {
                        this.videos = res.data.list || []
                        // 拆分广告主备注
                        this.setAdvertisersFirstRemark(this.model.selectAdvertisers, false)
                        this.model.rows = []
                        this.model.rows.push(this.createRow())
                        // console.log('this.model.rows44', this.model.rows)
                    })
                }

                //默认巨量
                this.model.media_source = 1
                this.changeChannel()

                //关闭面板
                this.fixedPanel = false
             
            }
        },
        changeChannel () {
            this.generateRules()

            if (this.model.platform_id && this.model.platform_type === 15) {
            
                this.model.rows.forEach(element => {
                    element.recharge_template_id = ''
                    element.media_source = 1
                    element.ad_callback_config_id = null
                });


                this.channels.forEach(element => {
                    if (this.model.distributor_id === element.id) {
                        this.channel_id = element.original_id
                    }
                });

                getRechargeTemplates({ platform_id: this.model.platform_id }).then(res => {
                    this.rechargeTemplates = res.data.list || []
                })
                adCallbackConfigs({ platform_id: this.model.platform_id }).then(res => {
                    this.adCallbackConfigs = res.data.list || []
                    this.changeMediaSource()
                })
            }
        },
        changeMediaSource(key = null) {
            // console.log('key', key)
            let showConfigs = []
            this.adCallbackConfigs.forEach(element => {
                 // 如果 showConfigs[element.media_source] 未初始化，先初始化为一个空数组
                if (!showConfigs[element.media_source]) {
                    showConfigs[element.media_source] = []
                }
                showConfigs[element.media_source].push(element)
            });

            this.showConfigs = showConfigs
            let ad_callback_config_id = null
            // if (this.model.platform_id && this.model.platform_id == 25) {
            //     ad_callback_config_id = 1791590421346313
            // } 

            if (key!=null) {
                this.model.rows[key].ad_callback_config_id = ad_callback_config_id
            } else {
                //所有的都重置
                this.model.rows.forEach(element => {
                    element.ad_callback_config_id = ad_callback_config_id
                });
            }
        },
        submitAddVideo() {
            if (!this.model.platform_id) {
               return this.$message.error('请先选择平台')
            }
            if (!this.addvideoModel.video_id) {
                return this.$message.error('请填写短剧ID')
            }
            if (this.model.platform_type == 4 && !this.addvideoModel.video_name) {
                return this.$message.error('请填写短剧名称')
            }
        
            addVideo({platform_id:this.model.platform_id, video_id:this.addvideoModel.video_id, video_name:this.addvideoModel.video_name}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('添加成功')
                    //拉取短剧列表
                    getVideos({ platform_id: this.model.platform_id }).then(res => {
                        this.videos = res.data.list || []
                    })
                } else {
                    this.$message.error(res.message)
                }
                this.closeAddVideo()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        addVideo () {
            this.showCreateAddForm = true
        },
        closeAddVideo () {
            this.showCreateAddForm = false
            this.addvideoModel.video_id = null
            this.addvideoModel.video_name = null
        },
        accessTo(route) {
            let controller = 'AdvertiserController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        syncAdCallbackConfig() {
            let data = {
                media_source : this.model.media_source,
                platform_id: this.model.platform_id
            }

            this.loading = true
            syncAdCallbackConfig(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步回传规则成功')
                    this.loading = false

                    adCallbackConfigs({ platform_id: this.model.platform_id }).then(res => {
                        this.adCallbackConfigs = res.data.list || []
                        this.changeMediaSource()
                    })
                   
                } else {
                    this.$message.error('同步失败')
                }
            }).catch(() => {
                this.loading = false
            })
        },

        addRow() {
            // this.rows.push(baseRow);
            this.model.rows.push(this.createRow());
            this.generateRules()
        },
        deleteRow (index) {
            this.model.rows.splice(index, 1);
            this.generateRules()
        },

        generateRules() {
            // 为每个 row 动态生成规则
            this.model.rows.forEach((_, index) => {
              this.$set(this.rules, `rows[${index}].adv_ids`, [{ required: true, message: '请选择本组广告主', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].chapter_num`, [{ required: true, message: '请填写集数', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].start_chapter`, [{ required: true, message: '请填写起始付费集数', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].price`, [{ required: true, message: '请填写单集价格', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].recharge_template_id`, [{ required: true, message: '请填写首充模板', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].follow_recharge_template_id`, [{ required: true, message: '请填写复充值模板', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].video_id`, [{ required: true, message: '请选择短剧', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].media_source`, [{ required: true, message: '请选择媒体渠道', trigger: 'change' }]);
              this.$set(this.rules, `rows[${index}].ad_callback_config_id`, [{ required: true, message: '请选择回传规则', trigger: 'change' }]);
            });
      
            // 合并基础规则和动态规则
            this.rules = { ...this.baseRules, ...this.rules };

            // console.log('合并后：',this.rules)
        },

        changeFixedPanel () {
            // console.log('点击了固定面板', this.fixedPanel)
            if (this.fixedPanel === true) {
                if (!this.model.platform_id) {
                    this.$message.error('请先选择平台')
                    this.fixedPanel = false
                    return
                }

                // if (!this.model.distributor_id) {
                //     this.$message.error('请先选择渠道')
                //     this.fixedPanel = false
                //     return
                // }


                let platform = this.platforms.find(item => item.id === this.model.platform_id);
                let app_type = platform.app_type;
                
                this.loading = true;
                // 请求规则
                getKvData({ type: 1 }).then(res => {
                    this.loading = false;
                    this.pt_rules = res.data || [];
                    this.model.rows = [];
                
                    // 用于存储分组的结果
                    let groupedAdvertisers = {};
                    let unmatchedAdvertisers = [];  // 存放那些不匹配任何规则的广告主
                
                    // 遍历 this.model.selectAdvertisers 进行分组
                    this.model.selectAdvertisers.forEach(advertiser => {
                        // advertiser.advertiser_name = '侠-飞杰-点众iaa高-aa' //TODO 调试
                        // 找到匹配的 rule key，检查 advertiser_name 是否以 rule 的 key 开头
                        let matchedRuleKey = Object.keys(this.pt_rules).find(key => advertiser.advertiser_name.startsWith(key));
                
                        if (matchedRuleKey) {
                            // 获取匹配的规则项
                            let ruleItem = this.pt_rules[matchedRuleKey];
                
                            // 判断 app_type，如果是 2，优先使用 recharge_template_name_dy
                            let templateGroup;
                            if (app_type === 2) {
                                templateGroup = ruleItem.recharge_template_name_dy || ruleItem.recharge_template_name;
                            } else {
                                templateGroup = ruleItem.recharge_template_name;
                            }
                
                            let callbackGroup = ruleItem.ad_callback_name;  // 使用 ad_callback_name 作为分组之一
                
                            // 使用 recharge_template_name 和 ad_callback_name 作为分组依据
                            let groupKey = `${templateGroup}-${callbackGroup}`;
                
                            // 如果该组还不存在，初始化为空数组
                            if (!groupedAdvertisers[groupKey]) {
                                groupedAdvertisers[groupKey] = {
                                    rule: ruleItem,  // 记录对应的规则
                                    advertisers: []  // 该组中的广告主
                                };
                            }
                
                            // 将广告主添加到对应的组
                            groupedAdvertisers[groupKey].advertisers.push(advertiser);
                        } else {
                            // 如果不匹配任何规则，将广告主放到 unmatchedAdvertisers 组中
                            unmatchedAdvertisers.push(advertiser);
                        }
                    });
                
                    // 如果有未匹配的广告主，将它们作为单独一组
                    if (unmatchedAdvertisers.length > 0) {
                        groupedAdvertisers['unmatched'] = {
                            rule: null,  // 没有对应的规则
                            advertisers: unmatchedAdvertisers
                        };
                    }

                    // console.log('分组后的结果', groupedAdvertisers)
                    // 遍历 groupedAdvertisers 的每个键值对
                    Object.entries(groupedAdvertisers).forEach(([key, element]) => {
                        console.log(key, element);  // 输出当前分组的值
                        let advertiserIds = element.advertisers.map(advertiser => advertiser.advertiser_id);
                        let rules = element.rule
                        if (app_type === 2 && platform.id == 33) {
                            rules.recharge_template_name = element.rule.recharge_template_name
                            rules.ad_callback_name = '自然日-100'
                        }

                        // 掌阅平台存在复充模版，展示复冲模版等于充值模版
                        if (platform.type === 15) {
                            rules.follow_recharge_template_name = element.rule.recharge_template_name
                        }

                        this.model.rows.push(this.createRow(advertiserIds,rules));

                        this.setAdvertisersFirstRemark(element.advertisers)
                    });
                   
                });



            } else {
                this.$message.success('还原为默认分组')
                //还原为默认
                this.model.rows = []
                this.model.rows.push(this.createRow());
                this.generateRules()
            }
        },
        changeVideo (row) {
            //固定面板模式，同步更改其他行的video_id
            if (this.fixedPanel === true) {
                this.model.rows.forEach(element => {
                    element.video_id = row.video_id
                });
            }
            this.getChapterNums(row.video_id)
        },
        changeStartChapter (row) {
            //固定面板模式，同步更改其他行的start_chapter
            if (this.fixedPanel === true) {
                this.model.rows.forEach(element => {
                    element.start_chapter = row.start_chapter
                });
            }
        },
        setAdvertisersFirstRemark (advertisers = [], isRows = true) {
            // 默认取每组的第一个广告组备注，分割剧名和收费章节
            let advertiser = advertisers[0]
            let video_name = ""
            let start_chapter = null
            if (advertiser && advertiser.remark) {
                // "[]"分割备注，得到剧名和收费章节
                const match = advertiser.remark.match(/\[([^\]]+)\]\[([^\]]+)\]/)
                if (match) {
                    video_name = match[1] // 第一个[]的内容
                    start_chapter = /^\d+$/.test(match[2]) ? parseInt(match[2], 10) : null // 第二个[]的内容，转换为数字
                } else {
                    // "-"分割备注，得到剧名和收费章节
                    let parts = advertiser.remark.split("-")
                    if (parts.length >= 2) {
                        const chapterCandidate = parts.pop()
                        start_chapter = /^\d+$/.test(chapterCandidate) ? parseInt(chapterCandidate, 10) : null // 最后一个部分
                        video_name = parts.pop() // 倒数第二个部分
                    }
                }
            }

            // 根据剧名匹配出短剧ID
            let video_id = ''
            let matchedVideo = this.videos.find(video => video.name === video_name)
            if (matchedVideo) {
                video_id = matchedVideo.out_id
            }

            if (!video_id) {
                // 未匹配到剧名，清空起始付费集
                start_chapter = null
            }

            // console.log('video_id', video_id)
            // console.log('start_chapter', start_chapter)

            // 循环 rows 数组对象，替换 video_id 和 start_chapter
            if (isRows) {
                this.model.rows.forEach(row => {
                    let firstAdvertiserId = row.adv_ids[0] || ""
                    if (firstAdvertiserId && firstAdvertiserId == advertiser.advertiser_id) {
                        row.video_id = video_id // 替换 video_id
                        row.start_chapter = start_chapter // 替换 start_chapter
                    }
                })
                // console.log('this.model.rows3', this.model.rows)
            } else {
                this.default_video_id = video_id
                this.default_start_chapter = start_chapter
            }
        },
        changeAdvs (row) {
            let firstAdvertiserId = row.adv_ids[0] || ""
            let advertisers = []
            for (let advertiser of this.model.selectAdvertisers) {
                if (firstAdvertiserId == advertiser.advertiser_id) {
                    advertisers = [advertiser];
                    break;
                }
            }
            this.setAdvertisersFirstRemark(advertisers)
            // console.log('this.model.rows2', this.model.rows)
        },
        getChapterNums (video_id = null, $defaulNum = 100) {
            // 默认显示100集
            let chapterNum = $defaulNum
            if (video_id) {
                this.videos.forEach(video => {
                    if (video.out_id == video_id) {
                        chapterNum = video.chapter_num || $defaulNum
                    }
                })
            }
            let nums = []
            for (let i = 1; i <= chapterNum; i++) {
                nums.push(i)
            }
            this.chapterNums = nums
        }
    }
}
